import object from 'helpers/object'


export const initialState = {
  order: {},
  total: null,
  isFetching: true,
}

export const setOrder = (state, payload) => (
  object.setIn(state, [ 'order' ], payload)
)

export const setTotal = (state, payload) => (
  object.setIn(state, [ 'total' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
